import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {QuestionComponent} from '../question.component';
import {QuestionBase} from '../../domain/question.base';
import {AddressLookupService, GetAddressIoAddress} from '../address-lookup.service';
import {GetAddressIoAddressToAddressTransformer} from '../../transformers/get-address-io-address-to-address.transformer';

@Component({
  selector: `crds-address-list-question-dropdown`,
  template: `
    <div [formGroup]="form">
      <div *ngIf="optionsPopulated && show">
        <label *ngIf="question.label" class="form-label" [attr.for]="question.key">{{question.label}}
          <span *ngIf="question.required"> *</span>
          <crds-form-error *ngIf="isInvalid" [question]="question"
                           [message]="question.errorMessage"></crds-form-error>
        </label>
        <select [id]="question.key"
                [formControlName]="question.key"
                class="form-control mb-2">
          <option *ngFor="let opt of question.options"
                  [ngValue]="opt.value"
                  #dropDownInput>
            {{opt.key}}
          </option>
        </select>

        <!-- QUESTION HINT -->
        <crds-question-hint [question]="question"></crds-question-hint>

        <p *ngIf="alert">
          <ngb-alert [dismissible]="false" type="secondary">
            <i class="material-icons">info</i> {{question.alert[form.get(question.key).value]}}
          </ngb-alert>
        </p>
      </div>
      <div class="selected-address" *ngIf="form.get('address').value">
        <label class="form-label">Selected Address:</label>
        <div [innerHtml]="form.get(question.key).value.line1"></div>
        <div *ngIf="form.get(question.key).value.line2" [innerHtml]="form.get(question.key).value.line2"></div>
        <div *ngIf="form.get(question.key).value.line3" [innerHtml]="form.get(question.key).value.line3"></div>
        <div *ngIf="form.get(question.key).value.line4" [innerHtml]="form.get(question.key).value.line4"></div>
        <div *ngIf="form.get(question.key).value.locality" [innerHtml]="form.get(question.key).value.locality"></div>
        <div *ngIf="form.get(question.key).value.town" [innerHtml]="form.get(question.key).value.town"></div>
        <div *ngIf="form.get(question.key).value.county"  [innerHtml]="form.get(question.key).value.county"></div>
        <div *ngIf="form.get(question.key).value.postCode" [innerHtml]="form.get(question.key).value.postCode"></div>
      </div>
    </div>`,
  styles: [
    `
      .selected-address {
        font-size: 0.75rem;
      }
    `
  ]
})
export class AddressListDropdownQuestionComponent extends QuestionComponent implements OnInit {
  @Input() form;
  @Input() question: QuestionBase<any>;
  @ViewChild('dropDownInput') input;
  type: string;

  constructor(private addressLookupService: AddressLookupService,
              private arrayToAddressTransformer: GetAddressIoAddressToAddressTransformer) {
    super();
  }

  ngOnInit() {
    this.addressLookupService.addressObservable
      .subscribe((addresses: GetAddressIoAddress[]) => {
        this.question.options = addresses.map((address) => {
          const addressKey = address.line_2 === ''
            ? address.line_1
            : [address.line_1, address.line_2].join(', ');
          return {key: addressKey, value: this.arrayToAddressTransformer.transform(address)};
        });
        this.form.get(this.question.key).patchValue(this.question.options[0].value);
      });
  }

  get optionsPopulated(): boolean {
    return this.question.options && this.question.options.length > 0;
  }

  get isInvalid() {
    return this.form.get(this.question.key).touched && this.form.get(this.question.key).invalid;
  }

  get show() {
    const showIfQuestionPopulated = this.question.showIf ?
      this.showIf :
      true;
    return (this.question.showIfPopulated !== true || (this.value)) &&
      showIfQuestionPopulated && this.question.show !== false;
  }

  get alert() {
    return this.question.alert && this.question.alert[this.form.get(this.question.key).value];
  }
}
